import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map p-mr-2" }, null, -1)
const _hoisted_4 = { class: "p-d-flex p-jc-between p-mt-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ZoneSummary = _resolveComponent("ZoneSummary")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "p-mb-3" }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('order.new.zone.title')), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_AutoComplete, {
            ref: "autocompleteRef",
            completeOnFocus: "",
            modelValue: _ctx.searchBox,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
            suggestions: _ctx.suggestions,
            field: "name",
            minLength: 2,
            placeholder: "Cerca città per nome",
            onItemSelect: _ctx.onSelect,
            onComplete: _ctx.search,
            onKeyup: _withKeys(_ctx.onEnter, ["enter"])
          }, {
            item: _withCtx(({item}) => [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(item.name), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "suggestions", "onItemSelect", "onComplete", "onKeyup"])
        ])
      ]),
      _: 1
    }),
    (_ctx.selected)
      ? (_openBlock(), _createBlock(_component_ZoneSummary, {
          key: 0,
          zone: _ctx.selected
        }, null, 8, ["zone"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_Button, {
        label: "Avanti",
        icon: "pi pi-chevron-right",
        disabled: !_ctx.isValid,
        onClick: _ctx.goNext
      }, null, 8, ["disabled", "onClick"])
    ])
  ]))
}